// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-LegacyCalendar-LastMinute-Overview-Overview__container--j\\+Bvm{max-width:38em;margin:0 auto;padding:2em 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "src-LegacyCalendar-LastMinute-Overview-Overview__container--j+Bvm"
};
export default ___CSS_LOADER_EXPORT___;
